import React, { useState, useRef, useEffect } from "react";
import { StyleSheet, TextInput, View, Keyboard } from "react-native";
import Text from "@components/AppText";
import colors from "@constants/color";
import { fontFamily } from "@utils/styles";

const Label = ({ label }) => (
  <View style={styles.labelContainer}>
    <Text style={styles.labelText}>{label}</Text>
  </View>
);

const AddComment = ({ reason, rvpData, setComment, currentComment }) => {
  const [commentText, setCommentText] = useState(currentComment || "");
  const inputRef = useRef();
  const {
    comment_placeholder_text,
    comment_text_length,
    comment_heading_text,
  } = rvpData;

  const handleBlur = () => {
    setComment(reason.key, commentText);
  };

  useEffect(() => {
    Keyboard.addListener("keyboardDidHide", () => {
      inputRef.current?.blur();
    });

    return () => {
      Keyboard.removeAllListeners("keyboardDidHide");
    };
  }, []);

  return reason?.comment_mandatory ? (
    <>
      <Label label={comment_heading_text} />
      <View style={styles.textInputContainer}>
        <TextInput
          value={commentText}
          placeholder={comment_placeholder_text}
          multiline
          numberOfLines={4}
          onChangeText={setCommentText}
          onBlur={handleBlur}
          style={styles.textArea}
          maxLength={comment_text_length}
          ref={inputRef}
          testID={`RVPCommentBox_${reason?.key}`}
        />
      </View>
      <Text style={styles.counterText}>
        {commentText.length}/{comment_text_length}
      </Text>
    </>
  ) : null;
};

const styles = StyleSheet.create({
  labelContainer: {
    marginVertical: 10,
    flexDirection: "row",
  },
  labelText: {
    color: colors.black,
    fontFamily: fontFamily.semiBold,
    fontSize: 16,
  },
  textInputContainer: {
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    padding: 10,
  },
  textArea: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    lineHeight: 20,
    minHeight: 90,
    justifyContent: "flex-start",
    textAlignVertical: "top",
    padding: 0,
  },
  counterText: {
    textAlign: "right",
    fontFamily: fontFamily.regular,
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.56)",
    marginTop: 4,
  },
});

export default AddComment;
